import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { LanguageProvider } from "./contexts/LanguageContext";
import PublicForm from "./pages/PublicForm";
import PublicPage from "./pages/store/PublicPage";
import { queryClient } from "./config/queryClient";

function AppWithProviders() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <LanguageProvider>
          <AppWithInterceptors />
        </LanguageProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

const loyaltifyDomains = [
  "localhost",
  "127.0.0.1",
  "loyaltify.io",
  "www.loyaltify.io",
  "staging.loyaltify.io",
  "staging.f.loyaltify.io",
  "f.loyaltify.io",
];

function AppWithInterceptors() {
  return (
    <Routes>
      {/* If domain is not loyaltify.io, show the white label routes */}
      {!loyaltifyDomains.includes(window.location.hostname) && (
        <>
          {/*
            Merchants hand out the bare domain, so the form has to render at the
            root itself — redirecting to /join would rewrite their branded URL.
            PublicPage cannot serve this route: it needs a "Loyaltify Club" page
            and has no guard when one is missing, so it just paints an empty
            shell. /join stays for links already in the wild.

            Note this leaves PublicPage with no custom-domain route at all: a
            merchant who later gets a club page still lands on the form here.
          */}
          <Route path="/" element={<PublicForm />} />
          <Route path="/join" element={<PublicForm />} />
          <Route path="/join/:formId" element={<PublicForm />} />
        </>
      )}

      {/* If domain is loyaltify.io, show the loyaltify routes */}
      {loyaltifyDomains.includes(window.location.hostname) && (
        <>
          <Route path="/:storeId" element={<PublicPage />} />
          <Route path="/:storeId/join" element={<PublicForm />} />
          <Route path="/:storeId/join/:formId" element={<PublicForm />} />
        </>
      )}
    </Routes>
  );
}

export default function App() {
  return <AppWithProviders />;
}
